<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="6" justify="center">
          <p class="header-title"> {{ $t('team_management.title') }} </p>
        </v-col>

        <v-col cols="12" sm="6" justify="center" class="pr-5">

        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" class="elevation-1"
                  hide-default-footer :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">

            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name" return-object outlined
                              dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="7">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined dense></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-btn color="primary" @click="showAssignDistrict(item)" :disabled="checkDisableAssign(item)">
          {{ $t('location_assign.select_team') }}
        </v-btn>
      </template>

      <template v-slot:[`item.context`]="{ item }">
        <span class="text-no-wrap">
          {{ item.context ? createTeamString(item) : 'NA'}}
        </span>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-dialog v-model="dialog" max-width="60%" persistent>
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          {{ $t('location_assign.select_team') }}
        </v-card-title>

        <v-card-text>
          <div class="text-center mt-5">
            <v-autocomplete v-model="selectDepartment" :items="departments" item-text="name"
                            v-bind:label="$t('location_assign.select_department')" filled outlined return-object>
            </v-autocomplete>

            <v-autocomplete v-model="selectTeam" :items="teams" item-text="name"
                            v-bind:label="$t('location_assign.select_team')" filled outlined return-object>
            </v-autocomplete>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn color="primary" @click="closeAssign">
            {{ $t('common.cancel') }}
          </v-btn>

          <v-btn color="primary" @click="assignTeam">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data: () => ({
    isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
    contextId: localStorage.getItem('context_id'),

    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    search: '',
    selectBlock: null,
    selectDepartment: null,
    selectTeam: null,

    dialog: false,
    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index',},
      {text: i18n.t('location_assign.district'), value: 'district_name'},
      {text: '', sortable: false, value: 'district_name', align: ' d-none'},

      {text: i18n.t('location_assign.team'), value: 'context'},
      {text: '', sortable: false, value: 'context.name', align: ' d-none'},


      {text: '', value: 'action', sortable: false}
    ],

    departments: [],
    teams: [],

    desserts: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},

    selectedDistricts: [],
    districts: [],
    demo: [
      {header: 'Group 1'},
      {province_name: 'Sandra Adams'},
      {province_name: 'Ali Connors'},
      {province_name: 'Trevor Hansen'},
      {province_name: 'Tucker Smith'},
      {divider: true},
      {header: 'Group 2'},
      {province_name: 'Britta Holt'},
      {province_name: 'Jane Smith '},
      {province_name: 'John Smith'},
      {province_name: 'Sandra Williams'}
    ],

    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ],

    selectProvince: {},
    provinces: []
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('team_management.add_team') : i18n.t('team_management.edit_team')
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    selectProvince(val) {
      if (val) {
        this.getDistrictByProvinceID(val.province_id);
      }
    },

    selectDepartment(val) {
      if (val) {
        this.getTeamByDepartmentId(val._id);
      }
    }
  },

  async created() {
    this.initialize();
    await this.getProvince();
    await this.getDepartment();
  },

  methods: {
    initialize() {
    },

    close() {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },

    closeAssign() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1;
    },

    async assignTeam() {
      const self = this;

      const requestBody = {
        context: this.selectTeam
      }

      try {
        const response = await this.$http.post('/api/assignTeamLocation/' + self.editedItem.district_id, requestBody);
        if (response.data && response.data.success) {
          this.editedItem.context = this.selectTeam;
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
          self.editedItem = {};
        } else if (response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        console.log(e.stack);
        alert(i18n.t('validate.request_error'));
      }

      this.closeAssign();
    },

    async showAssignDistrict(item) {
      const self = this;
      self.editedIndex = self.desserts.indexOf(item)
      self.editedItem = item;
      console.log(self.editedItem.context);

      if (self.editedItem.context) {
        // self.selectDepartment = self.departments.find(item => (item._id === self.editedItem.context.parents[1]._id));
        self.selectDepartment = self.editedItem.context.parents[1];
        self.selectTeam = self.editedItem.context;
      }

      self.dialog = true;
    },

    createTeamString(item) {
      return item.context.parents[1].name + "/" + item.context.name
    },

    checkDisableAssign(item) {
      if (this.$isAdmin || this.$getUserCategory >= 4) {
        return false;
      } else {
        if (item.context && item.context.parents[1]._id !== this.$getUserContextID ) {
          return true;
        }

        return false;
      }
    },

    async getDepartment() {
      try {
        if (this.isAdmin) {
          const response = await this.$http.get(process.env.VUE_APP_GET_SALE_DEPARTMENT_BY_LEVEL + '?level=1');
          if (response.data && response.data.success) {
            this.departments = [].concat(response.data.data);
          }
        } else {
          const response = await this.$http.get(process.env.VUE_APP_CONTEXT_URL + this.contextId);
          if (response.data && response.data.success) {
            this.departments = [].concat(response.data.data);
          }
        }

          if (this.departments.length > 0) {
            this.selectDepartment = this.departments[0];
          }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getTeamByDepartmentId(departmentId) {
      try {
        const response = await this.$http.get(process.env.VUE_APP_CONTEXT_IN_CONTEXT_URL + departmentId);

        if (response.data && response.data.success) {
          this.teams = [].concat(response.data.data);
          if (this.teams.length > 0 && !this.selectTeam) {
            this.selectTeam = this.teams[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getDistrictByProvinceID(provinceId) {
      this.desserts = await this.$getDistrictByProvince(provinceId);
      this.desserts.forEach((item, index) => item.index = index + 1);
      this.loading = false;
    },

    async getProvince() {
      try {
        if (this.isAdmin) {
          this.provinces = await this.$getAllProvinces();
          if (this.provinces.length > 0) {
            this.selectProvince = this.provinces[0];
          }
        } else {
          this.provinces = await this.$getProvincesByContext(this.contextId);
          if (this.provinces.length > 0) {
            this.selectProvince = this.provinces[0];
          }
        }

      } catch (e) {
        console.log(e.stack);
      }
    }
  }
}
</script>

<style scoped>

.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>